/**
 * FeatureTile.jsx
 * Reusable feature/benefit tile component for the QuitPact homepage.
 *
 * AC 1.1.1 – AC tasks covered:
 *   - Renders a named benefit tile with icon, title, and description
 *   - Used to display: "Understand Your Risk", "Real-Time Support",
 *     "Track Your Progress" (and any future tiles)
 *   - Fully accessible: uses semantic HTML, aria-label on icon container
 *
 * Props:
 *   icon        {ReactNode}  Icon element (SVG or emoji) — optional
 *   title       {string}     Tile heading (required)
 *   description {string}     Short explanatory text (required)
 *   className   {string}     Extra CSS classes (optional)
 *
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import './FeatureTile.css';

const FeatureTile = ({ icon, title, description, className = '' }) => {
  return (
    <article className={`feature-tile ${className}`} aria-label={title}>

      {/* -- Icon container (decorative, hidden from screen readers) -- */}
      {icon && (
        <div className="feature-tile__icon" aria-hidden="true">
          {icon}
        </div>
      )}

      {/* -- Tile heading -- */}
      <h3 className="feature-tile__title">{title}</h3>

      {/* -- Tile description -- */}
      <p className="feature-tile__description">{description}</p>

    </article>
  );
};

export default FeatureTile;
